import React from 'react';
import SEO from '../SEO';
import { useLanguage } from '../../i18n';

const Impressum = () => {
  const { t } = useLanguage();

  return (
    <div className="impressum-container">
       <SEO
        title={t("seo.impressumTitle")}
        description={t("seo.impressumDescription")}
        url="https://fixanor.com/impressum"
        image="https://fixanor.com/images/hero-image-webp.webp"
      />
      <h1>{t("impressum.heading")}</h1>

      <p className="subtitle">{t("impressum.updated")}</p>

      <section>
        <h2>{t("impressum.companyTitle")}</h2>
        <p>
          <strong>Fixanor Software Solutions S.R.L.</strong><br />
          {t("impressum.registered")}<br />
          {t("impressum.registrationNumber")}: J20/2547/043001<br />
          {t("impressum.euid")}: ROONRC.J2025047043001<br />
          {t("impressum.taxCode")}: 52059132<br />
          {t("impressum.certificate")}: B5361985, {t("impressum.issuedOn")}<br />
          {t("impressum.incorporationAct")}: No. 548210 from 2025-07-01<br />
          {t("impressum.legalForm")}: {t("impressum.legalFormValue")}<br />
          {t("impressum.registrationDate")}: 2025-07-01<br />
          {t("impressum.status")}: {t("impressum.active")}<br />
          {t("impressum.duration")}: {t("impressum.unlimited")}
        </p>
      </section>

      <section>
        <h2>{t("impressum.headOfficeTitle")}</h2>
        <p>
          {t("impressum.addressLabel")}: {t("impressum.address")}<br />
          {t("common.phone")}: +40 730 941 464<br />
          {t("common.email")}: contact@fixanor.com
        </p>
      </section>

      <section>
        <h2>{t("impressum.representativeTitle")}</h2>
        <p>
          {t("impressum.ceo")}: Szilard Zsebe<br />
          {t("impressum.responsible")}
        </p>
      </section>

      <section>
        <h2>{t("impressum.vatTitle")}</h2>
        <p>
          {t("impressum.vatText1")}<br />
          {t("impressum.vatText2")}
        </p>
      </section>

      <section>
        <h2>{t("impressum.copyrightTitle")}</h2>
        <p>
          {t("impressum.copyrightText")}
        </p>
      </section>

      <section>
        <h2>{t("impressum.odrTitle")}</h2>
        <p>
          {t("impressum.odrText1")} <br />
          {t("impressum.odrText2")}
          <br />
          <a
            href="https://commission.europa.eu/live-work-travel-eu/consumer-rights-and-complaints_en"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://commission.europa.eu/consumer-rights-and-complaints
          </a>
        </p>
      </section>

      <section>
        <h2>{t("impressum.disclaimerTitle")}</h2>
        <p>
          {t("impressum.disclaimerText")}
        </p>
      </section>

      <style>{styles}</style>
    </div>
  );
};

const styles = `
  .impressum-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 40px 20px;
    font-family: inherit;
    color: var(--color-text);
    line-height: 1.6;
    background-color: var(--color-bg);
  }

  .impressum-container h1 {
    font-size: 36px;
    margin-bottom: 10px;
    text-align: center;
  }

  .impressum-container .subtitle {
    font-size: 14px;
    text-align: center;
    color: var(--color-subtle);
    margin-bottom: 30px;
  }

  .impressum-container h2 {
    font-size: 22px;
    margin-top: 30px;
    margin-bottom: 10px;
    color: var(--color-heading);
    text-align: left;
  }

  .impressum-container p {
    margin-bottom: 10px;
    text-align: left;
  }

  .impressum-container a {
    color: var(--color-link);
    text-decoration: none;
  }

  .impressum-container a:hover {
    text-decoration: underline;
  }
`;

export default Impressum;
